import { BitkitAlert, BitkitLink } from '@bitrise/bitkit-v2';

export const DeployStepOutdatedAlert = ({ workflowEditorUrl }: { workflowEditorUrl?: string }) => {
  return (
    <BitkitAlert
      variant="warning"
      titleText="Update your deploy Step to view the test summary"
      messageText={
        <>
          You&apos;re using an outdated version of the &quot;Deploy to bitrise.io&quot; Step.{' '}
          {workflowEditorUrl ? (
            <BitkitLink href={workflowEditorUrl} textDecoration="underline">
              Update this Step
            </BitkitLink>
          ) : (
            'Update this Step'
          )}{' '}
          in your Workflow to get an easy-to-browse summary of failed tests.
        </>
      }
    />
  );
};
